"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OauthAuthorizationService", {
    enumerable: true,
    get: function() {
        return OauthAuthorizationService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _ncError = require("~/helpers/ncError");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let OauthAuthorizationService = class OauthAuthorizationService {
    buildRedirectUrl(redirectUri, params) {
        const url = new URL(redirectUri);
        Object.entries(params).forEach(([key, value])=>{
            if (value !== undefined && value !== null) {
                url.searchParams.set(key, value);
            }
        });
        return url.toString();
    }
    async createAuthorizationCode(params) {
        const { clientId, userId, redirectUri, state, codeChallenge, codeChallengeMethod = 'S256', scope, workspaceId, baseId, resource } = params;
        // Validate client exists
        const client = await _models.OAuthClient.getByClientId(clientId);
        if (!client) {
            _ncError.NcError.badRequest('invalid_client');
        }
        // Validate redirect URI inline
        if (!redirectUri) {
            _ncError.NcError.badRequest('invalid_redirect_uri');
        }
        try {
            const url = new URL(redirectUri);
            if (url.protocol !== 'https:' && url.protocol !== 'http:') {
                _ncError.NcError.badRequest('invalid_redirect_uri');
            }
            // Exact match required
            if (!client.redirect_uris.includes(redirectUri)) {
                _ncError.NcError.badRequest('invalid_redirect_uri');
            }
        } catch (unused) {
            _ncError.NcError.badRequest('invalid_redirect_uri');
        }
        // Validate state inline
        if (state) {
            if (state.length < 16 || state.length > 1024) {
                _ncError.NcError.badRequest('invalid_state');
            }
            const allowedChars = /^[a-zA-Z0-9._-]+$/;
            if (!allowedChars.test(state)) {
                _ncError.NcError.badRequest('invalid_state');
            }
        }
        // Validate code challenge inline
        if (!codeChallenge) {
            _ncError.NcError.badRequest('code_challenge_required');
        }
        if (codeChallengeMethod !== 'S256') {
            _ncError.NcError.badRequest('invalid_code_challenge');
        }
        if (codeChallenge.length !== 43) {
            _ncError.NcError.badRequest('invalid_code_challenge');
        }
        const base64urlPattern = /^[A-Za-z0-9_-]+$/;
        if (!base64urlPattern.test(codeChallenge)) {
            _ncError.NcError.badRequest('invalid_code_challenge');
        }
        const expiresAt = new Date(Date.now() + this.AUTHORIZATION_CODE_EXPIRES_IN_MS);
        const grantedResources = {};
        // Validate workspace access if specified
        if (workspaceId) {
            try {
                const wsUser = await _models.WorkspaceUser.get(workspaceId, userId);
                if (!wsUser) {
                    _ncError.NcError.forbidden('User does not have access to the specified workspace');
                }
                grantedResources.workspace_id = workspaceId;
            } catch (error) {
                if (error instanceof _ncError.NcError || error instanceof _nocodbsdk.NcBaseError) throw error;
                _ncError.NcError.badRequest('invalid_workspace_id');
            }
        }
        // Validate base access if specified
        if (baseId) {
            try {
                var _bases_find;
                const bases = await _models.BaseUser.getProjectsList(userId, {});
                const base = bases == null ? void 0 : (_bases_find = bases.find) == null ? void 0 : _bases_find.call(bases, (b)=>b.id === baseId);
                if (!base) {
                    _ncError.NcError.forbidden('User does not have access to the specified base');
                }
                // If workspace is specified, ensure base belongs to that workspace
                if (workspaceId && base.fk_workspace_id !== workspaceId) {
                    _ncError.NcError.badRequest('Base does not belong to the specified workspace');
                }
                grantedResources.base_id = baseId;
            } catch (error) {
                if (error instanceof _ncError.NcError || error instanceof _nocodbsdk.NcBaseError) throw error;
                _ncError.NcError.badRequest('invalid_base_id');
            }
        }
        return await _models.OAuthAuthorizationCode.insert({
            fk_client_id: clientId,
            fk_user_id: userId,
            redirect_uri: redirectUri,
            state,
            code_challenge: codeChallenge,
            code_challenge_method: codeChallengeMethod,
            scope,
            resource,
            granted_resources: Object.keys(grantedResources).length > 0 ? grantedResources : null,
            expires_at: expiresAt.toISOString()
        });
    }
    constructor(){
        // Authorization code expires in 10 minutes
        this.AUTHORIZATION_CODE_EXPIRES_IN_MS = 10 * 60 * 1000;
    }
};
OauthAuthorizationService = _ts_decorate([
    (0, _common.Injectable)()
], OauthAuthorizationService);
